import '@mdi/font/css/materialdesignicons.css'; /* eslint-disable-line */
import 'vuetify/styles' /* eslint-disable-line */
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import theme from './theme';

const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme,
  components,
  directives,
});

export default vuetify;
